import styled from 'styled-components'
import PackagesCardSummary from './PackagesCardSummary'

export const StyledPackagesCardSummary = styled(PackagesCardSummary)`
  span {
    margin-right: 20px;
  }
`
